<template>
  <Grid
    class="custom-timeslot-card rounded-[var(--border-radius)] p-2 m-2"
    data-test="custom-timeslot"
  >
    <Col12 class="pb-0">
      <div class="flex justify-between">
        <span class="block text-[14px] font-medium">{{
          t(
            'sites.stationAppConfig.preOrder.form.dropoff.custom.timeslots.displayCard.timeslotLabel',
          )
        }}</span>
        <div v-if="!disabled" class="flex">
          <IconButton
            class="c-icon-button timeslot-action-button"
            data-test="edit-timeslot"
            @click="emit('edit')"
          >
            <template #icon><i class="material-symbols-rounded text-[1.5rem]">edit</i></template>
          </IconButton>
          <IconButton
            class="c-icon-button timeslot-action-button delete-timeslot-button"
            data-test="remove-timeslot"
            @click="emit('remove')"
          >
            <template #icon><i class="material-symbols-rounded text-[1.5rem]">delete</i></template>
          </IconButton>
        </div>
      </div>
    </Col12>
    <Col12>
      <div class="flex justify-start">
        <span>{{ startTime }}</span>
        <i class="material-symbols-rounded mx-2">arrow_right_alt</i>
        <span>{{ endTime }}</span>
      </div>
    </Col12>
    <Col12 class="pb-0">
      <span class="block text-[14px] font-medium">{{
        t(
          'sites.stationAppConfig.preOrder.form.dropoff.custom.timeslots.displayCard.dropoffSpotsLabel',
        )
      }}</span>
    </Col12>
    <Col12 class="py-0">
      <ol class="list-none pl-0 m-0">
        <li v-for="(spot, index) in timeslot.destinations" :key="spot" class="mb-1">
          <span class="font-bold mr-2">{{ index + 1 }}.</span>{{ spot }}
        </li>
      </ol>
    </Col12>
  </Grid>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { DateTime } from 'luxon';
import { IconButton } from '@centric-os/components/src/core/buttons/icon-button';
import type { CustomTimeslot } from '../types';

const props = defineProps<{ timeslot: CustomTimeslot; disabled?: boolean }>();
const emit = defineEmits<{ edit: []; remove: [] }>();
const { t } = useI18n();

// Lowercase am/pm, matching the station card.
const display = (time: string): string =>
  DateTime.fromFormat(time, 'HH:mm').toFormat('h:mm a').toLowerCase();
const startTime = computed(() => display(props.timeslot.start_time));
const endTime = computed(() => display(props.timeslot.end_time));
</script>

<style scoped lang="scss">
.custom-timeslot-card {
  border: 1px solid #e0e0e0;
}

.timeslot-action-button {
  height: 22px !important;
  width: 22px !important;
}

// Target the icon itself: the theme's text-button colour otherwise wins on the root.
.delete-timeslot-button .material-symbols-rounded {
  color: $errorColor;
}
</style>
